import React from "react";
import Navbars from "../../Components/Navbars";
import BackgroundSolutionApplication from "../../Assets/header background solution application.png";
import Footer from "../../Components/Footer";
import SaPublic1 from "../../Assets/sa public 1.png";
import SaPublic1KOR from "../../Assets/sa public 1 KOR.png";
import SaPublic2 from "../../Assets/sa public 2.png";
import OtherSolutions1 from "../../Assets/App Solution 4.png";
import OtherSolutions2 from "../../Assets/App Solution 5.png";
import OtherSolutions3 from "../../Assets/App Solution 6.png";
import LeftMenu from "../../Components/LeftMenu";
import HeaderContent from "../../Components/HeaderContent";
import OtherContent from "../../Components/OtherContent";
import ButtonUp from "../../Components/ButtonUp";
import { useLanguage } from "../../Context/LanguageContext";

export default function SaPublicSecurity() {
  const { language } = useLanguage();

  return (
    <>
      <Navbars currentBold={3} />
      <HeaderContent
        title={`${
          language === "ENG" ? "AERY Solution Applications" : "솔루션 활용분야"
        }`}
        subtitle={`${
          language === "ENG"
            ? "Public Security Social Safety Net"
            : "공공 방범/치안/사회안전망"
        }`}
        background={BackgroundSolutionApplication}
        colorBorder={"#f48e35"}
      />
      <div className="bg-[#fefefe] py-20 flex flex-row items-start w-fit">
        <LeftMenu
          currentChoose={1}
          currentBold={"Public Security Social Safety Net"}
        />
        <div className="flex flex-col mx-0 sm:mx-8">
          <div className="flex flex-col mx-8">
            <h2 className="font-bold text-3xl lg:text-4xl mb-8">
              {language === "ENG"
                ? "Supervised and Self-Learning AI Management"
                : "방범 AI 신경망 활용"}
            </h2>
            <p
              className="font-normal text-xl"
              data-aos="fade-down"
              data-aos-duration="750"
            >
              {language === "ENG"
                ? "When abnormal behavior is detected, a warning signal is given to the control center. It is possible to respond quickly to the scene."
                : "이상 동작이 감지되면 관제센터에 경고 신호가 전달됩니다. 신속한 현장 대응이 가능합니다."}
            </p>
            <img
              src={language === "ENG" ? SaPublic1 : SaPublic1KOR}
              alt="Sa public 1"
              onContextMenu={(e) => e.preventDefault()}
              className="w-full self-center p-2 md:p-8 border-2 border-black rounded-3xl my-12 shadow-md"
              data-aos="fade-down"
              data-aos-duration="750"
            />
          </div>
          <div className="bg-[#1a1a1a] py-20">
            <div className="mx-8" data-aos="fade-up" data-aos-duration="750">
              <img
                src={SaPublic2}
                alt="Sa public 3"
                onContextMenu={(e) => e.preventDefault()}
                className="w-full mx-auto"
              />
              <p className="text-[#fefefe] text-center text-xl sm:text-2xl border-2 rounded-3xl p-4">
                {language === "ENG"
                  ? "When abnormal behavior is detected, a warning signal is given to the control center. It is possible to respond quickly to the scene."
                  : "이상행동 감지 시 관제센터에 경고신호를 주어 빠른 현장 대처가 가능하다."}
              </p>
            </div>
          </div>
          <OtherContent
            title={`${
              language === "ENG" ? "Other Solution Area" : "기타 솔루션 영역"
            }`}
            titlecard1={`${
              language === "ENG" ? "Bank Security" : "은행 방범/보이스피싱/안전"
            }`}
            titlecard2={`${
              language === "ENG"
                ? "Shopping Malls Security Facilities Crime Prevention"
                : "상가/보안시설 방범/치안"
            }`}
            titlecard3={`${
              language === "ENG"
                ? "Customized Recommendation Service for the Service Industry"
                : "서비스업 맞춤형 추천 서비스"
            }`}
            image1={OtherSolutions1}
            image2={OtherSolutions2}
            image3={OtherSolutions3}
            href1={"/sa-bank-security"}
            href2={"/sa-shopping-malls"}
            href3={"/sa-customized"}
          />
        </div>
      </div>
      <ButtonUp />
      <Footer />
    </>
  );
}
